import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import ConditionalButton from "../../../layout/conditional-button";
import Table from "../../../layout/table";

import { list as listReconciliations } from "../../../actions/bank.reconciliations";
import { loading, send as pageInfo } from "../../../actions/page";
import { format as formatDate } from "../../../utils/date";
import { currency as formatCurrency } from "../../../utils/number";

class BankReconciliations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      page: 0,
      size: 25,
      pages: 1,
    };
  }

  componentDidMount = async () => {
    await this.props.pageInfo({ title: "Bank Reconciliation", breadcrumb: "Reconciliation" });
    await this.loadData();
  };

  loadData = async () => {
    this.props.loading(true);
    try {
      const items = await this.props.listReconciliations();
      this.setState({
        data: items || [],
        pages: 1,
      });
    } finally {
      this.props.loading(false);
    }
  };

  get headers() {
    return [
      {
        header: "Statement Date",
        source: "statementDate",
        className: "text-muted text-small text-uppercase w-15",
        onRender: (value, row) => (
          <a href={`/dashboard/accounting/reconciliations/${row.uuid}`}>{formatDate(value)}</a>
        ),
      },
      {
        header: "Financial Account",
        source: "FinancialAccount.name",
        className: "text-muted text-small text-uppercase w-25",
        onRender: (_value, row) => row?.FinancialAccount?.name || "",
      },
      {
        header: "Status",
        source: "status",
        className: "text-muted text-small text-uppercase w-15",
      },
      {
        header: "Beginning",
        source: "beginningBalance",
        className: "text-muted text-small text-uppercase w-15 text-end",
        dataClassName: "text-end",
        onRender: (value) => formatCurrency(Number(value || 0)),
      },
      {
        header: "Ending",
        source: "endingBalance",
        className: "text-muted text-small text-uppercase w-15 text-end",
        dataClassName: "text-end",
        onRender: (value) => formatCurrency(Number(value || 0)),
      },
    ];
  }

  onNew = () => {
    window.location.href = "/dashboard/accounting/reconciliations/add";
  };

  render() {
    return (
      <>
        <Col md="8" className="float-right text-end">
          <ConditionalButton
            enabledVariant="outline-primary"
            tooltip="New Reconciliation"
            display
            enabled
            onEnabledClick={this.onNew}
            icon="plus"
          >
            New Reconciliation
          </ConditionalButton>
        </Col>

        <Col xs="12">
          <Table
            headers={this.headers}
            page={this.state.data}
            size={this.state.size}
            index={this.state.page}
            pages={this.state.pages}
            searchable={false}
            sizable={false}
          />
        </Col>
      </>
    );
  }
}

BankReconciliations.propTypes = {
  loading: PropTypes.func.isRequired,
  pageInfo: PropTypes.func.isRequired,
  listReconciliations: PropTypes.func.isRequired,
};

export default connect(null, {
  loading,
  pageInfo,
  listReconciliations,
})(BankReconciliations);
